import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from '@angular/core';
import { PassKeyTermsAndConditionsComponent } from './pass-key-terms-and-conditions.component';

class PassKeyTermsAndConditionsSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  resolver: ComponentFactoryResolver;
  viewContainerRef: ViewContainerRef;
  passKeyTermsAndConditionsComponent: ComponentRef<PassKeyTermsAndConditionsComponent>;

  constructor(formId: string, payload: object) {

  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
    console.log('PassKeyTermsAndConditionsSession: ' + this.formId);
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.resolver = (clientContext as any).resolver;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }
  endSession(): void {
    console.log('PassKeyTermsAndConditionsSession: ' + this.formId);
  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    console.log('PassKeyTermsAndConditionsSession: ' + this.formId);
    const self = this;
    self.viewContainerRef.clear();

    const factory: ComponentFactory<PassKeyTermsAndConditionsComponent> =
            self.resolver.resolveComponentFactory(PassKeyTermsAndConditionsComponent);
    self.passKeyTermsAndConditionsComponent = self.viewContainerRef.createComponent(factory);

    self.passKeyTermsAndConditionsComponent.instance.onAcceptTermsAndConditionsSubmit = self.onAcceptTermsAndConditions.bind(self);
    self.passKeyTermsAndConditionsComponent.instance.onDeclineTermsAndConditionsSubmit = self.onDeclineTermsAndConditions.bind(self);

    // const journeyPayload = this.payload as JourneyPayload;
    // const action = journeyPayload.actions[0] as ActionsInPayload;

    return new Promise((resolve, reject) => {
      self.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

          self.submitBlock = null;
        } catch (e) {

        }
      };
    });
  }
  onContinue(payload: object): void {
    console.log('PassKeyTermsAndConditionsSession ' + this.formId + ' payload:', payload);
  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  /** Non UIFormSession interface Functions */
  private async onAcceptTermsAndConditions(payload: object) {
    this.submitBlock({accept: true});
  }

  private onDeclineTermsAndConditions(payload: object) {
    this.submitBlock({accept: false});
  }
  // async passkeyRegister() {
  //    const result = await (window as any).tsPlatform.webauthn.isPlatformAuthenticatorSupported();

  //    if (result )
  //     {
  //         const username = this.clientContext['cookieService'].get('userEmail-username');

  //         const res = await (window as any).tsPlatform.webauthn.register(username, {
  //         limitSingleCredentialToDevice: false ,
  //         displayName: username ,
  //         allowCrossPlatformAuthenticators: false,
  //         registerAsDiscoverable: false});

  //         if (res){
  //         // console.log(data3);
  //         console.log('');

  //         this.submitBlock({
  //         action: 'submit',
  //         webauthntoken: res
  //       });
  //     }
  //   }
  //     else{
  //        console.log('Not Platform support');
  //     }
  // }

}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default PassKeyTermsAndConditionsSession;
